import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalsService } from "../globals.service";

@Component({
  selector: "app-resetpassword",
  templateUrl: "./resetpassword.component.html",
  styleUrls: ["./resetpassword.component.css"],
})
export class ResetPasswordComponent implements OnInit {
  public loading: boolean = false;
  public password: string;
  public passwordConfirm: string;
  public passwordValidationMessage = "VALIDATING";

  public constructor(
    private http: HttpClient,
    private router: Router,
    public globalsService: GlobalsService,
  ) {
    this.globalsService.log("resetpassword.component.constructor()...");
  }

  public isValidPassword() {
    return (
      this.password === this.passwordConfirm &&
      this.passwordValidationMessage === ""
    );
  }

  public ngOnInit() {}

  public validatePassword(password: string) {
    this.passwordValidationMessage = "VALIDATING";

    const path = `login/password/validate?password=${password}`;

    this.http
      .get<any>(path)
      .toPromise()
      .then((result) => {
        const valMessage = result.validationMessage;
        this.passwordValidationMessage = valMessage;
        if (valMessage !== "") {
          this.globalsService.handleInfo(valMessage);
        }
      })
      .catch((error) => {
        this.globalsService.handleError(
          error,
          "Error validating password.",
          false,
        );
      });
  }

  public passwordFieldsValid() {
    return this.isValidPassword() && this.password === this.passwordConfirm;
  }

  public resetPassword() {
    this.loading = true;

    const path =
      `login/resetpassword/?` +
      `resetPasswordToken=${this.globalsService.getResetPasswordToken()}&newPassword=${this.password}`;

    this.http
      .get<any>(path)
      .toPromise()
      .then((result) => {
        this.loading = false;
        this.globalsService.setResetPasswordToken(null);
        this.globalsService.setShowLogin(true);
        this.router.navigateByUrl("/login");
        if (result.success === true) {
          this.globalsService.handleSuccess(result.message, "Password Reset.");
        } else {
          this.globalsService.handleError(
            result.message,
            "Could Not Reset Password.",
            false,
          );
        }
      })
      .catch((error) => {
        this.loading = false;
        this.globalsService.setResetPasswordToken(null);
        this.globalsService.setShowLogin(true);
        this.globalsService.handleError(
          error,
          "Could not reset password.",
          false,
        );
      });
  }
}
